export enum AvailableLoginFlow {
  LoginByOtp = 1,
  LoginByPassword = 2,
  LoginByBiometrics = 3,
  LoginByEmailOtp = 4,
  LoginByQuickLogin = 5,
}

export enum AvailableLoginMethods {
  LoginByPhoneOtp = 1,
  LoginByEmailOtp = 2,
  LoginByUsernamePassword = 3,
  LoginByEmailPassword = 4,
  LoginByPhonePassword = 5,
  LoginByGenericBiometrics = 6,
  LoginByFaceIdBiometrics = 7,
  LoginByFingerprintBiometrics = 8,
  LoginByQuickLogin = 9,
}
